import { useState, createContext } from "react";
// import {useContext} from "react-router-dom";
export const Cartcontext = createContext();
export default function Cartcontextprovider({ children }) {
  const [cartdata, setcartdata] = useState(JSON.parse(localStorage.getItem("cartData"))||[]);
  const handlecart = (obj) => {
    localStorage.setItem("cartData",JSON.stringify([...cartdata,obj]))
    setcartdata([...cartdata,obj])
  };
  return (
    <Cartcontext.Provider value={{ cartdata, handlecart,setcartdata }}>
      {children}
    </Cartcontext.Provider>
  );
}
